import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { SiteLayoutProvider } from './context/SiteLayoutContext';
import { AuthProvider } from './context/AuthContext';

// Layout Components
import AnnouncementBar from './components/AnnouncementBar/AnnouncementBar';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import MobileBottomNav from './components/MobileBottomNav/MobileBottomNav';
import Toast from './components/Toast/Toast';
import AuthModal from './components/AuthModal/AuthModal';

// Pages — the home page loads with the site; every other page is downloaded the first time it's opened
import Home from './pages/Home/Home';

import './App.css';

const Collections = lazy(() => import('./pages/Collections/Collections'));
const CollectionDetail = lazy(() => import('./pages/CollectionDetail/CollectionDetail'));
const ProductDetail = lazy(() => import('./pages/ProductDetail/ProductDetail'));
const Search = lazy(() => import('./pages/Search/Search'));
const Wishlist = lazy(() => import('./pages/Wishlist/Wishlist'));
const Cart = lazy(() => import('./pages/Cart/Cart'));
const Checkout = lazy(() => import('./pages/Checkout/Checkout'));
const OrderConfirmation = lazy(() => import('./pages/OrderConfirmation/OrderConfirmation'));
const Account = lazy(() => import('./pages/Account/Account'));
const Orders = lazy(() => import('./pages/Orders/Orders'));
const OrderDetail = lazy(() => import('./pages/OrderDetail/OrderDetail'));
const About = lazy(() => import('./pages/About/About'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const SizeGuide = lazy(() => import('./pages/SizeGuide/SizeGuide'));
const Policy = lazy(() => import('./pages/Policy/Policy'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));

function App() {
  return (
    <BrowserRouter>
      <SiteLayoutProvider>
      <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <div className="app-root">
            <AnnouncementBar />
            <Header />

            <main className="app-main" id="main-content">
              <Suspense fallback={<div className="page-loading" aria-busy="true" />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/collections/:slug" element={<CollectionDetail />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/search" element={<Search />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
                <Route path="/account" element={<Account />} />
                <Route path="/account/orders" element={<Orders />} />
                <Route path="/account/orders/:orderId" element={<OrderDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/size-guide" element={<SizeGuide />} />
                <Route path="/policies/:slug" element={<Policy />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              </Suspense>
            </main>

            <Footer />
            <MobileBottomNav />
            <Toast />
            <AuthModal />
          </div>
        </WishlistProvider>
      </CartProvider>
      </AuthProvider>
      </SiteLayoutProvider>
    </BrowserRouter>
  );
}

export default App;
